import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSignaturepadModule } from 'ngx-signaturepad2';
import { QuillModule } from 'ngx-quill';

import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from './../../shared/shared.module';

//Component Imports
import { HomeIndexComponent } from './home-index/home-index.component';
import { BulletinComponent } from './bulletin/bulletin.component';
import { NgSelectModule } from '@ng-select/ng-select';

//Modal Imports
import { HotlistModalComponent } from './../../modals/home/hotlist-modal/hotlist-modal.component';

import {
  PdfViewerModule, LinkAnnotationService, BookmarkViewService,
  MagnificationService, ThumbnailViewService, ToolbarService,
  NavigationService, TextSearchService, TextSelectionService, TextFieldSettings,
  PrintService, FormDesignerService, FormFieldsService, AnnotationService, ValidateFormFieldsArgs
} from '@syncfusion/ej2-angular-pdfviewer';

@NgModule({
  declarations: [
    HomeIndexComponent,
    BulletinComponent,
    HotlistModalComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    NgxSignaturepadModule,
    SharedModule,
    FormsModule,
    NgSelectModule,
    QuillModule,
    PdfViewerModule
  ],
  exports: [
    HomeIndexComponent
  ],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, AnnotationService, TextFieldSettings,
    TextSearchService, TextSelectionService, PrintService, FormDesignerService, FormFieldsService]
})
export class HomeModule {
}
